import axios from "axios";

const URL = 'https://isolution.dev.br:8085';
//const URL = 'http://localhost:8085';

const api = axios.create({
    baseURL: URL
});

export default api;